import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NeedMoreHelpModalComponent } from './need-more-help-modal/need-more-help-modal.component';
import { GlobalShadowStyleDirective } from '@ptl/global-components';

@Component({
    selector: 'app-need-more-help',
    templateUrl: './need-more-help.component.html',
    styleUrls: ['./need-more-help.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class NeedMoreHelpComponent extends GlobalShadowStyleDirective implements OnInit {

  @Input() buttonLabel: string;
  @Input() modalTitle: string;
  @Input() modalText: string;

  constructor(
    private matDialog: MatDialog,
  ) { 
    super();
  }

  ngOnInit() {
  }

  openNeedMoreHelpModal() {
    this.matDialog.open(NeedMoreHelpModalComponent, {
      maxWidth: '800px',
      data: {
        modalTitle: this.modalTitle,
        modalText: this.modalText
      }
    });
  }
}
